var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeleteIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 5.5,
    stroke: "#313131",
    strokeOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.33333 16.6667H8.28333L14.8 10.15L13.85 9.2L7.33333 15.7167V16.6667ZM6 18V15.1667L14.8 6.38333C14.9333 6.26111 15.0806 6.16667 15.2417 6.1C15.4028 6.03333 15.5722 6 15.75 6C15.9278 6 16.1 6.03333 16.2667 6.1C16.4333 6.16667 16.5778 6.26667 16.7 6.4L17.6167 7.33333C17.75 7.45556 17.8472 7.6 17.9083 7.76667C17.9694 7.93333 18 8.1 18 8.26667C18 8.44444 17.9694 8.61389 17.9083 8.775C17.8472 8.93611 17.75 9.08333 17.6167 9.21667L8.83333 18H6ZM14.3167 9.68333L13.85 9.2L14.8 10.15L14.3167 9.68333Z",
    fill: "#313131",
    fillOpacity: 0.8
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.60b38edfcbb6b48cedf44fc9b69de3da.svg";
export { ForwardRef as ReactComponent };